const DEFAULT_HOOKS = ['activate', 'mount', 'update'];

export { DEFAULT_HOOKS };
//# sourceMappingURL=constants.js.map



// WEBPACK FOOTER //
// ./node_modules/@sentry/vue/esm/constants.js